// Reusable button to bulk re-translate FR → EN/IT/ES/DE/PT/ZH/PL via Gemini.
// Used on the Events & Articles admin tabs.
import { useState } from "react";
import api from "@/lib/api";

export default function RetranslateButton({ collection, label }) {
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState("");

  const run = async (force) => {
    const confirmMsg = force
      ? `Re-traduire TOUTES les ${label} (réécriture complète des 7 langues à partir du FR) ? L'opération peut prendre quelques minutes.`
      : `Compléter les traductions manquantes des ${label} en EN/IT/ES/DE/PT/中文/Polski ?`;
    if (!window.confirm(confirmMsg)) return;
    setBusy(true);
    setMsg("");
    try {
      const { data } = await api.post(
        `/admin/i18n/retranslate?collection=${collection}&force=${force ? "true" : "false"}`
      );
      setMsg(`✓ ${data.translated} traduits sur ${data.processed} ${label} (${data.skipped} ignorés).`);
    } catch (e) {
      setMsg(`Erreur : ${e?.response?.data?.detail || "échec"}`);
    } finally { setBusy(false); }
  };

  return (
    <div className="inline-flex flex-col gap-1" data-testid={`retranslate-${collection}`}>
      <div className="inline-flex gap-2">
        <button onClick={() => run(false)} disabled={busy}
                data-testid={`retranslate-${collection}-fill`}
                className="btn btn-outline"
                style={{ fontSize: "0.68rem", padding: "0.5rem 0.85rem", letterSpacing: "0.08em" }}
                title="Complète seulement les traductions manquantes (rapide, économique)">
          {busy ? "Traduction…" : "🌐 Compléter traductions"}
        </button>
        <button onClick={() => run(true)} disabled={busy}
                data-testid={`retranslate-${collection}-force`}
                className="btn btn-outline"
                style={{ fontSize: "0.68rem", padding: "0.5rem 0.85rem", letterSpacing: "0.08em", borderColor: "var(--cinnabar)", color: "var(--cinnabar)" }}
                title="Réécrit toutes les traductions à partir du FR (utile après modifications)">
          {busy ? "…" : "↻ Re-traduire tout"}
        </button>
      </div>
      {msg && <div className="font-body text-xs" style={{ color: msg.startsWith("✓") ? "var(--moss)" : "var(--cinnabar)" }}>{msg}</div>}
    </div>
  );
}
